const zh_HK = {
    //ALL
    "Confined Space Program": "密閉空間系統",
    "Confined Space": "密閉空間",
    "Program": "系統",
    "Dashboard": "儀表板",
    "Alert Reporting": "提醒/警告報告",
    "Today's Schedule": "今天的行程表",
    "Entry": "出入記錄",
    "Project": "專案項目",
    "Contract": "合約",
    "Worker": "工作人員",
    "Company": "公司",
    "Search": "搜尋",
    "Add": "新增",
    "Edit": "編輯",
    "Save": "儲存",
    "Back": "返回",
    "Select File": "選擇檔案",
    "Last Updated By": "最後更新人員",
    "Last Updated At": "最後更新日期",
    "Date": "日期",
    "Time": "時間",
    "Created By : ": "創建者 : ",
    "Updated By : ": "更新者 : ",
    "Updated On : ": "更新日期 : ",
    "No data available": "無記錄",
    "Logout": "登出",
    "Hello, ": "您好, ",
    "Delete": "刪除",
    "Create Date": "新增日期",
    //Equipment Page
    "Equipment": "裝備",
    "Add New Equipment": "新增裝備",
    "Equipment Type": "裝備類別",
    "Type": "類別",
    "RealTimeType" : "實時監測類別",
    "RFID No.": "RFID 編號.",
    "Equipment Name": "裝備名稱",
    "Brand / Manufacturer": "品牌/生產商",
    "Manufacturer": "品牌/生產商",
    "Equipment No.": "裝備編號",
    "Model No.": "裝備型號",
    "Model": "裝備型號",
    "Serial No.": "裝備序號",
    "Purchase Date": "購入日期",
    "Expiry Date": "到期日期",
    "Expire Date": "到期日期",
    "Next Cal. / Cert Due Date": "下個測量日",
    "Certification: ": "認證文件: ",
    "Equipment Photo: ": "裝備照片: ",
    "Cert Due Date": "下個測量日",
    "Are you sure to ADD NEW or EDIT contract": "你確定要新增/修改裝備資料?",
    "Search Equipment": "搜尋裝備",
    //Contract Page
    "Contract Name": "合約名稱",
    "Contract No.": "合約編號",
    "Contract Title": "合約名稱",
    "Contract Detail": "合約明細",
    "Create Project": "創建新專案項目",
    "Start Date": "開始日",
    "End Date": "結束日",
    "Add New Contract": "新增合約",
    "Remark": "備註",
    "Are you sure to add new contract?": "你確定要新增合約?",
    //Worker Page
    "Worker Name": "工人名稱",
    "Add New Worker": "新增工人",
    "Workers Registration Card: ": "工人註冊證:",
    "Safety Card: ": "安全卡:",
    "Workers Photo:": "工人照片:",
    "Certified Work of Confined Space Operation: ": "核准工人證明書:",
    "Training Details": "培訓詳情",
    "Add Training Detail": "新增培訓詳情",
    "Training Date": "培訓日期",
    "Training Certificate": "培訓證書",
    "Attachments": "附件",
    "No training details found.": "沒有培訓資訊",
    "Worker Photo": "工人照片",
    "Worker Registration Card": "工人註冊證",
    "Safety Card": "安全卡",
    "Certified Work of Confined Space Operation": "核准工人證明書",
    "No certificates found.": "沒有證書",
    //Company Page
    "Company Name": "公司名稱",
    "Is Active": "啟用中",
    "Add New Company": "新增公司",
    "Are you sure to update this company?": "你確定要更新公司資料?",
    "Are you sure to add new company?": "你確定要新增公司資料?",
    "Company Detail": "公司詳細資料",
    //Project Page
    "Project No.": "專案項目編號",
    "Project No": "專案項目編號",
    "Project Name": "專案項目名稱",
    "Project Manager": "專案項目負責人",
    "Add New Project": "新增專案項目",
    "Project Company": "專案項目負責公司",
    "Tel": "聯絡電話",
    "Add New Location": "新增地點",
    "Project Location": "專案項目地點",
    //Entry Page
    "Location": "地點",
    "Location of Confined Space": "井口地點",
    "Status": "狀態",
    "Start Time": "開始時間",
    "End Time": "結束時間",
    //Work Schedule Page
    "Today's Work Schedule": "今天的工作計劃表",
    "To be Complete": "待完成",
    "Remaining Work Total": "剩餘工作總計",
    "Competent person": "主管/負責人",
    "Standby Person": "待命人員",
    "Certified Worker 1": "已認可人員 1",
    "Certified Worker 2": "已認可人員 2",
    "Certified Worker 3": "已認可人員 3",
    "Certified Worker 4": "已認可人員 4",
    "Certified Worker": "已認可人員",
    "On Site Equipment": "現場裝備",
    "Edit Work Schedule": "編輯工作計劃表",
    "Add Work Schedule": "新增工作計劃表",
    "Work Type": "工作類型",
    "Add Worker": "新增工人",
    "Document": "文件",
    "Risk Assessment: ": "風險評估: ",
    "Work Permit: ": "工作證: ",
    "Project No.:": "專案項目編號: ",
    "Project Name:": "專案項目編號: ",
    "Loaction No.:": "地點編號: ",
    "Location: ": "地點: ",
    "Date: ": "日期: ",
    "Start Time:": "開始時間: ",
    "End Time:": "結束時間: ",
    "Location of Confided Space: ": "密閉空間地點: ",
    "Coordinates: ": "座標: ",
    "On Site Worker": "現場工作人員",
    "Add Equipment": "新增裝備",
    //DashBoard Page
    "Alert": "提醒/警告",
    "Alert by category": "按類別提醒/警告",
    "Overview Worker Status": "工人狀況概覽",
    "Today Completed": "今日已完成",
    "No Alert": "無記錄",
    "OngoingCount": "正在進行中",
    "CompletedCount": "已完結",
    "ExitsCount": "已離開",
    //Alert Reporting Page
    "Critical": "嚴重",
    "Medium": "中等",
    "Minor": "輕微",
    "Alert List": "提醒/警告清單",
    "Alert Detail": "提醒/警告詳細",
    "Edit Alert": "編輯提醒/警告",
    "Level": "等級",
    "Active": "已啟用",
    "InActive": "不啟用",
    "CO2": "二氧化碳",
    "O2": "氧",
    "CH4": "甲烷",
    "LEL": "可燃氣體濃度",
    "CO": "一氧化碳",
    "H2S": "硫化氫",
    "PM2.5": "懸浮微粒",
    "Environment Temperature": "環境溫度",
    "Heart Rate": "心率",
    "Body Temperature": "體溫",
    "Over": "過高",
    "Under": "過低",
    "Title": "名稱",
    "Content": "內容",
    "Occurred Location": "發生地點",
    "Involved Worker": "相關工人",
    //Login
    "Login": "登入",
    "Email:": "電郵",
    "Password:": "密碼",
    "Forgot Password?": "忘記密碼?",
    //Other
    "Schedule": "日程",
    "Location No.:": "地點編號:",
    "Name Of Confined Space:": "密閉空間名稱",
    "Apply": "確認",
    "QR Code": "二維碼",
    //Safety Page
    "Safety Monitoring Page": "安全實時監察",
    //Components
    "Today": "今天",
    "This Week": "這星期",
    "This Month": "這個月",
    "Lastest Alert": "最近的提醒/警告",
    "Total Worker": "總工人數量",
    "Worker Status": "工人狀況",
    "No. of Worker": "數量",
    //Report Page
    "Internal Report": "內部報告",
    "Report": "報告",
    "Reporting": "報告",
    "Generate Weekly Report": "生成每周報告",
    "Generate Monthly Report": "生成每月報告",
    //Work Record Page
    "Work Record": "工作匯報",
    "Role": "身份",
    "On Site Day": "到場日",
    "Date/Time In": "入井時間",
    "Date/Time Out": "出井時間",
    "Time In": "入井時間",
    "Time Out": "出井時間",
    "Personnel Entering - Worker 1": "入井人員 1",
    "Personnel Entering - Worker 2": "入井人員 2",
    //Work Schedule Page
    "Work Schedule": "工作日程",
    "Add New Schedule": "新增日程",
    "Schedule Start Time": "日程開始時間",
    "Schedule End Time": "日程結束時間",
    //Real Time Page
    "Real Time Monitoring Worker": "工人狀況實時監察",
    "Other People": "其他人員",
    "Weather Monitoring": "天氣實時監察",
    "Confined Space Monitoring": "密閉空間實時監察",
    "Real Time Camera": "現場影像實時監察",
    "Stand by": "待命中",
    "In": "已進入",
    "Out": "已離開",
    "Timer": "計時器",
    "Oxygen": "氧氣",
    "Change": "需要更換",
    "Enough": "充足",
    "Gas Sensor Status": "氣體檢測狀態",
    "Online": "在線",
    "Offline": "離線",
    "Blood Oxygen": "血氧",
    "Check Out Project": "完成本次任務",
    "temperature": "氣溫",
    "Safely Monitoring": "安全監控",
    "WorkType": "工作類型",
    //Alert Translation
    "Detect worker having high heart rate": "工人心跳過快",
    "Detect worker having high body temperature": "工人體溫過高",
    "Detect worker having no motion": "工人長時間沒有移動",
    "Detect person without helmet around the work site": "沒有戴安全帽進入工作地點",
    "Detect person without vest around the work site": "沒有穿著背心進入工作地點",
    "Detect person entered confined space": "有人進入密閉空間",
    // WorkPermitPage 新增
    "Enter Confined Space Work Permit": "進入密閉空間工作許可證明書",
    "Work Site": "工作場地",
    "Work Content": "工作內容",
    "Contractor/Owner": "總承建商/東主",
    "Approved Qualified Person": "被委任合資格人士姓名",
    "Risk Assessment Report Date and Time": "危險評估報告日期及時間",
    "Entry Date": "可進入密閉空間的日期",
    "Validity Period Until (Date)": "此工作許可證明書有效期限至(日期)",
    "Approved Workers": "核准工人",
    "Maximum Stay Time for Approved Workers (Hours)": "核准工人進入密閉空間內最長可逗留時間(小時)",
    "Name": "姓名",
    "ID Number": "持有證件編號",
    "ID Expiry Date": "證件有效期限",
    "Worker Signature": "工人簽署",
    "Actions": "操作",
    "Clear": "清除",
    "Standby Workers": "候命人員",
    "Add Standby Worker": "新增候命人員",
    "Duty": "責任",
    "Rescue Workers on Site": "在場的救援人員",
    "Add Rescue Worker": "新增救援人員",
    "Emergency Rescue Training Date": "接受緊急救援訓練日期",
    "Ground Pipe Work": "地底喉管工作",
    "This confined space work is subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, which refers to ground pipe work. Therefore, the contractor/owner must": "本密閉空間工作是屬於《工廠及工業經營(密閉空間)規例》第9(b)條所述的地底喉管工作，因此承建商/東主必須",
    "ensure that any person entering the confined space or remaining in it is properly equipped with appropriate respiratory equipment; and": "確保任何進入該密閉空間或在其逗留的人已妥當地：",
    "use appropriate monitoring equipment (designed for explosion-proof) to continuously monitor the gas in the confined space until all persons have left the confined space; and": "使用合適的監測設備(須為防爆設計)，對密閉空間內的氣體作連續性的監測，直到所有人離開該密閉空間止；及",
    "This confined space work is not subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, for the following reasons:": "本密閉空間工作並不屬於《工廠及工業經營(密閉空間)規例》第9(b)條所述的地底喉管工作，原因如下：",
    "Reason": "原因",
    "Note: The above options must be mutually exclusive.": "註：上述選擇必須二選一",
    "Isolation Measures": "隔離措施",
    "Measure": "措施",
    "Signature": "簽署",
    "Date and Time": "日期及時間",
    "Cleaning and Ventilation Control Measures": "清洗及通風控制措施",
    "Air Testing": "空氣測試",
    "Add Air Test": "新增空氣測試",
    "Test Date": "測試日期",
    "Air Monitoring Equipment Model": "空氣監測設備型號",
    "Air Monitoring Equipment Serial Number": "空氣監測設備序列號",
    "Air Monitoring Equipment Calibration Validity Until": "空氣監測設備校準有效期至",
    "Test Location": "測試位置",
    "Test Time": "測試時間",
    "Lower Limit (Percentage)": "爆炸下限(百分比)",
    "Hydrogen Sulphide (ppm)": "硫化氫(ppm)",
    "Carbon Monoxide (ppm)": "一氧化碳(ppm)",
    "Responsible Person for Air Testing": "空氣測試負責人姓名",
    "Responsible Person Signature": "負責人簽署",
    "Delete This Test": "刪除此測試",
    "Remove Location": "移除位置",
    "Add Test Location": "新增測試位置",
    "□ I hereby confirm that I have tested the air in this confined space and found no hazardous gases and no oxygen deficiency.": "□ 經上述空氣測試，本人確定本密閉空間沒有任何具危害性的氣體存在以及並無空氣氧氣情況。",
    "Safety Measures Required for Entry into Confined Spaces": "進入密閉空間所需的安全預防措施",
    "Emergency Rescue Equipment Provided": "已提供的緊急救援器具",
    "Quantity/Number": "套/數量",
    "Description": "說明",
    "Tripod and Crane": "三腳架及絞車",
    "Other": "其他",
    "I hereby confirm that the emergency rescue equipment provided is sufficient and in satisfactory condition, and is readily available at all times.": "已確認上述緊急救援器具數目足夠而狀況令人滿意，並且隨時可供取用。",
    "List of Protective Equipment Provided": "已提供的防護設備清單",
    "Piece": "件",
    "Clothing": "衣物",
    "Declarations by Owner/Contractor or Authorized Representative": "東主 / 承建商或其授權代表聲明",
    "Valid Date": "有效日期",
    "Position": "職位",
    "Cancel": "取消",
    "wear appropriate approved breathing apparatus; and": "配戴適當的認可呼吸器具；及",
    "wear a safety harness connected to a lifeline": "配戴適當並與救生繩連接的安全吊帶",
    "Stakeholder Type": "利害關係人類型",
    "Owner": "東主",
    "Contractor": "承建商",
    "Authorized Representative": "授權代表",
    "Edit Work Permit": "編輯工作許可證",
    "Edit Risk Assessment": "編輯危險評估",
    "Create Work Permit": "建立工作許可證",
    "Loading Work Permit Data...": "載入工作許可證數據中...",
          "Add Risk Assessment": "新增風險評估",
      "Please Create Work Schedule First": "請先建立工作計劃表",
          "WorkPermitCertificate": "工作許可證明書",
      "ApprovedWorkPermitCertificate": "簽收工作許可證明書",
      "CompletionCertificate": "完工證明書",
      "CancelledWorkPermitCertificate": "註銷工作許可證明書",
      "View Work Permit": "查看工作許可證",
      "Close": "關閉",
      // Risk Assessment
      "Risk Assessment": "危險評估",
      "Create Risk Assessment": "建立危險評估",
      "View Risk Assessment": "查看危險評估",
      "Loading Risk Assessment Data...": "載入危險評估數據中...",
      "Workplace": "工作場地",
      "Subcontractor (if applicable)": "分判商(如適用)",
      "Competent Person Name": "合資格人士姓名",
      "Basic Information": "基本資料",
      "Competent Person Information": "合資格人士資料",
      "No.": "編號",
      "Assessment Items": "評估事項",
      "Assessment Results": "評估結果",
      "Required Safety Precautions": "所需採取的安全預防措施",
      "Severity of Consequence": "後果嚴重性",
      "Likelihood of Incident": "事故發生可能性",
      "Risk Rating": "危險評級",
      "Very Severe (3)": "非常嚴重 (3)",
      "Severe (2)": "嚴重 (2)",
      "Minor (1)": "輕微 (1)",
      "Very Likely (3)": "非常可能 (3)",
      "Likely (2)": "可能 (2)",
      "Unlikely (1)": "不太可能 (1)",
      "High Risk (>=6)": "高危險性 (>=6)",
      "Medium Risk (3-5)": "中危險性 (3-5)",
      "Low Risk (<=2)": "低危險性 (<=2)",
      "Hours": "小時",
      "Risk Rating Table Reference": "有關「後果嚴重性」、「事故發生可能性」及「危險評級」等定義,可參考本評估表最後部分的危險評級表。",

      "Work Schedule ID": "工作計劃表編號",
      "Work Date": "工作日期",
      "Ongoing": "進行中",
      "Expired": "已過期",
      "Permit Status": "許可證狀態",
      "Equipment Checklist": "裝備清單:",
      "Risk Assessment Content": "危險評估內容",
      "Certificate Expiry Date": "證件有效期期限",
      "Certificate Number": "持有證件編號",
      "Project Detail": "專案項目詳細資料",
      "Work Schedule Detail": "工作日程詳細資料",
      "Edit Contract": "編輯合約",
      "Phone Number": "電話號碼",
      "Worker Detail": "工人詳細資料",
      "User": "用戶",
      "Add New User": "新增用戶",
      "Registration Request": "註冊請求",
      "Role Name": "身份",
      "Email": "電郵",
      "Password": "密碼",
      "Repeat Password": "確認密碼",
      "User Detail": "用戶詳細資料",
      "User Name": "用戶名稱",
      "Edit New User": "編輯用戶",
      "Weekly Report": "每周報告",
      "Monthly Report": "每月報告",
      "Select Month": "選擇月份",
      "Permission": "權限",
      "Edit Project Detail": "編輯專案項目詳細資料",
      "assessed": "已評估",
      "not yet start": "未評估",
      "completed": "已完成",
      "cancelled": "已取消",
      "Cancelled": "已取消",
      "pending": "待處理",
      "Pending": "待處理",
      "acknowledged": "已確認",
      "Risk Assessment Not Completed": "風險評估尚未完成",
      "Risk Assessment Status": "風險評估狀態",
      "Download Risk Assessment": "下載風險評估",
      "Download PDF": "下載PDF",
      "Missing Risk Assessment": "風險評估未完成",
      "Not Allowed to Work": "未經許可工作",
}

export default zh_HK;